import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { RootState } from 'modules';
import apiClient, { WrappingApiClient } from 'libs/api/apiClient';
import { CSNewsFarameworksIntroduction } from 'modules/learning//boardTypes';
import { CMAIN_THEMES, CFINANCE_THEME } from 'constants/learningboard.const';
import { ERoute } from 'enums/route.enum';
import styled from 'styled-components';
import { device } from 'GlobalStyles';
import learningBottom from 'assets/images/pages/framework/bottom.webp';
import lockImg from 'assets/images/pages/framework/consultingIcon/lock.webp';
import SubjectTemplate from '../parts/SubjectTemplate';

interface ISubjectCard {
  order: string;
}

const LearningBoard = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const history = useHistory();
  const requestHitCount = () => {
    return WrappingApiClient(apiClient.get(`/drill/framework?board=Frameworks`));
  };

  useEffect(() => {
    requestHitCount();
  }, []);

  return (
    <SubjectTemplate pageTitle='주제를 선택하세요'>
      <StyledThemeList>
        {currentUser?.primary_field === 'finance' ? (
          <>
            {CFINANCE_THEME.map(({ link, id, icon, name, color }) => (
              <>
                {link === 'basic_guide' && (
                  <StyledCard onClick={() => history.push(`${ERoute.CSLearningBoard}/${link}/view`)} key={id}>
                    <StyledCardImg order={color}>
                      <StyledCardIcon src={icon} />
                    </StyledCardImg>
                    <StyledCardTitle>{name}</StyledCardTitle>
                  </StyledCard>
                )}

                {link !== 'basic_guide' && (
                  <StyledCard
                    onClick={() =>
                      currentUser?.is_finance_frameworks_membership &&
                      history.push(`${ERoute.CSLearningBoard}/${link}/view`)
                    }
                    key={id}
                  >
                    <StyledCardImg order={color}>
                      <StyledCardIcon src={icon} />

                      {!currentUser?.is_finance_frameworks_membership && (
                        <StyledCardLock>
                          <img src={lockImg} alt='' />
                        </StyledCardLock>
                      )}
                    </StyledCardImg>
                    <StyledCardTitle>{name}</StyledCardTitle>
                  </StyledCard>
                )}
              </>
            ))}
          </>
        ) : (
          CMAIN_THEMES.map(({ link, id, icon, name, color }) => (
            <Link to={`${ERoute.CSLearningBoard}/${link}/view`} key={id}>
              <StyledCard>
                <StyledCardImg order={color}>
                  <StyledCardIcon src={icon} />
                </StyledCardImg>
                <StyledCardTitle>{name}</StyledCardTitle>
              </StyledCard>
            </Link>
          ))
        )}
      </StyledThemeList>
      <StyledNotice>
        {currentUser?.primary_field !== 'finance' && (
          <>
            <StyledNoticeTitle>어디서부터 시작해야 할지 모르겠다면?</StyledNoticeTitle>
            <Link to={CSNewsFarameworksIntroduction}>
              <StyledNoticeBtn>케이스 스터디 활용법</StyledNoticeBtn>
            </Link>
          </>
        )}
      </StyledNotice>
    </SubjectTemplate>
  );
};

export default React.memo(LearningBoard);

const StyledThemeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  width: 810px;
  margin-top: 40px;

  @media screen and ${device.lg} {
    width: 540px;
  }

  @media screen and ${device.sm} {
    width: 280px;
  }
`;

const StyledCard = styled.div`
  position: relative;
  width: 254px;
  margin: 0px 8px 20px 8px;
  cursor: pointer;
`;

const StyledCardImg = styled.div<ISubjectCard>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 195px;
  border-radius: 10px 10px 0px 0px;
  background-color: ${({ order }) => order};
`;

const StyledCardLock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px 10px 0px 0px;
  background-color: rgba(224, 224, 224, 0.6);
`;

const StyledCardIcon = styled.img`
  width: 40%;
`;

const StyledCardTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
  border-radius: 0px 0px 10px 10px;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #000000;
  background-color: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
`;

const StyledNotice = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 248px;
  margin-top: 98px;
  background-image: url(${learningBottom});
  background-position: center;
  background-size: cover;
`;

const StyledNoticeTitle = styled.div`
  margin-bottom: 13px;
  font-size: 24px;
  line-height: 32px;
  color: #ffffff;
  text-align: center;
  word-break: keep-all;

  @media screen and ${device.sm} {
    width: 70%;
  }
`;

const StyledNoticeBtn = styled.div`
  padding: 12px 15px;
  border-radius: 8px;
  font-weight: 700;
  line-height: 20px;
  color: #ffffff;
  background-color: #3cac40;
  cursor: pointer;
`;
